export default __webpack_public_path__ + "static/media/hour-1.9f8e6d0f.svg";